/**
 * Absolute core of the framework.
 * Default options of all classes are registrated here.
 * The options can be overruled by the developer. Nutshell.options is public
 *
 * @author Michel Heitbrink
 */
class Nutshell {

    constructor() {
        this.options = {};
    }

    registrateDefaults(name, options) {

        if ( options && typeof options == 'object' ) {

            if ( this.options[name] == undefined ) {
                this.options[name] = {};
            }

            this.options[name] = { ...options };
        }
    }

}

export default new Nutshell();

/*
---
name: Nutshell
category: JavaScript
---
Absolute core of the framework. Default options of all classes are registrated here. The options can be overruled by the developer. Nutshell.options is public.

```js
import { Nutshell } from '@nutshell/core';

Nutshell.options.ServerRequest.secure = true;
*/
